<template>
  <van-dialog v-model:show="isShowDlg" :showConfirmButton="false" :closeOnClickOverlay="true">
    <div class="dlg-content">
      <span class="title">邮箱账号</span>
      <div class="content">
        <img src="/images/wx-qrcode.png" alt="" />
        <div>
          因系统改版，关闭了邮箱登录功能，已通过邮箱注册的老用户，请扫二维码，添加六合小助手，人工更换手机号，因给您带来不便，更换手机号后，赠您100积分表示感谢。
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script setup>
import { ref } from "vue"

const isShowDlg = ref(false)
const open = () => {
  isShowDlg.value = true
}
defineExpose({
  open
})
</script>

<style lang="stylus" scoped>
:deep(.van-popup.van-dialog) {
  background: #fff !important;
}
.dlg-content {
  padding: 16px;
  text-align: center;
  .title {
    width: 51px;
    height: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #203152;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding: 16px;
    background: #E7F4FE;
    border-radius: 8px;
    img {
      width: 200px;
      height: 200px;
      margin-bottom: 15px;
    }
  }
}
</style>